import * as u from "react";
import { i as f, b, E as v, x as p, a as m, r as y, c as F } from "../createReactComponent-58f9bea8.mjs";
import { n } from "../property-9daa16cd.mjs";
import { r as h } from "../state-7560d4dc.mjs";
import { e as g } from "../class-map-2994e95e.mjs";
import { r as S } from "../button-7600b6ca.mjs";
import { d as z, e as T, r as $ } from "../icon-c572aa57.mjs";
import { b as c, r as U } from "../loader-8e6cf7b9.mjs";
import { g as E } from "../utils-cf5bbdd1.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../style-map-c3339321.mjs";
import "../icon-button-87ac6b5d.mjs";
import "../tooltip-cb602d1f.mjs";
var k = Object.defineProperty, O = Object.getOwnPropertyDescriptor, o = (l, e, t, i) => {
  for (var a, r = i > 1 ? void 0 : i ? O(e, t) : e, d = l.length - 1; d >= 0; d--)
    (a = l[d]) && (r = (i ? a(e, t, r) : a(r)) || r);
  return i && r && k(e, t, r), r;
}, D = ((l) => (l.MEDIUM = "medium", l.LARGE = "large", l))(D || {}), M = ((l) => (l.MB = "MB", l.KB = "KB", l))(M || {});
class s extends v {
  constructor() {
    super(...arguments), this.errorMessage = { text: "", footer: "File [size/type] not accepted . Try again." }, this.sizeOfAllFilesByte = 0, this.error = !1, this.mb = 1048576, this.kb = 1024, this.mainText = "Drag and drop files here or", this.buttonText = "Click to upload", this.icon = !1, this.interactive = !1, this.errorState = !1, this.allFiles = [], this.fileTypes = ".jpg,.jpeg,.pdf,.png", this.maxSize = 2, this.maxSizeUnit = "MB", this.size = "large", this.footerText = this.getMessage(this.maxSize, this.maxSizeUnit), this.helpText = "", this.errorMsg = "", this.disabled = !1, this.singleFileUpload = !1, this.iconLabel = "", this.uploadedFileTypes = [], this.uploadedFileNames = [], this.header = "", this.fileUploadStates = {};
  }
  getMessage(e, t) {
    const i = this.fileTypes.split(".");
    return `Only ${i.join(" ").substring(1)} file${i.length <= 2 ? "" : "s"}. ${e}${t} max file size.`;
  }
  validateFiles(e) {
    let t = 0;
    if ((e instanceof FileList ? Array.from(e) : Object.values(e)).forEach((i) => {
      t += i.size;
      const a = function(r) {
        let d;
        return d = r === "image/svg+xml" ? ["svg"] : r.split("/"), d.length > 1 ? d[1] : d[0];
      }(i.type);
      this.fileTypes.indexOf(a) === -1 && (this.error = !0);
    }), !this.error) {
      const i = this.maxSizeUnit === "MB" ? this.maxSize * this.mb : this.maxSize * this.kb;
      this.sizeOfAllFilesByte + t > i && (this.error = !0);
    }
    this.error || (this.sizeOfAllFilesByte += t), this.interactive = !1;
  }
  handleDropZoneDragover(e) {
    e.preventDefault(), this.interactive = !0, this.error = !1;
  }
  handleDropZoneDragleave(e) {
    e.preventDefault(), this.interactive = !1;
  }
  handleDropZoneDrop(e) {
    var i;
    if (e.preventDefault(), this.disabled)
      return;
    const t = (i = e.dataTransfer) == null ? void 0 : i.files;
    t && t.length > 0 && this.handleChange(t);
  }
  handleUploadedFile(e) {
    e.preventDefault();
    const t = e.target;
    t != null && t.files && this.handleChange(t.files);
  }
  handleChange(e) {
    this.singleFileUpload && this.resetFileUploadState(), this.validateFiles(e), Array.from(e).forEach((t) => {
      this.processFile(t);
    }), this.error || this.dispatchChangeEvent();
  }
  resetFileUploadState() {
    this.allFiles = [], this.sizeOfAllFilesByte = 0, this.uploadedFileNames = [], this.uploadedFileTypes = [];
  }
  setFileStateToError(e) {
    this.fileUploadStates = { ...this.fileUploadStates, [e]: c.ERROR };
  }
  processFile(e) {
    const t = e.name, i = function(a) {
      var r;
      return ((r = a.name.split(".").pop()) == null ? void 0 : r.toUpperCase()) || "UNKNOWN";
    }(e);
    this.addFile(e, t, i), this.setFileStateToStart(t), setTimeout(() => this.setFileStateToInProgress(t), 500), setTimeout(() => {
      this.error ? this.setFileStateToError(t) : this.finalizeFileState(t);
    }, 2e3);
  }
  addFile(e, t, i) {
    this.allFiles.push(e), this.uploadedFileNames.push(t), this.uploadedFileTypes.push(i);
  }
  setFileStateToStart(e) {
    this.fileUploadStates[e] = c.TO_START;
  }
  setFileStateToInProgress(e) {
    this.fileUploadStates[e] = c.IN_PROGRESS, this.requestUpdate();
  }
  finalizeFileState(e) {
    this.error ? this.fileUploadStates[e] = c.ERROR : this.isFileSizeValid() ? this.fileUploadStates[e] = c.COMPLETED : this.fileUploadStates[e] = c.ERROR, this.requestUpdate();
  }
  isFileSizeValid() {
    const e = this.maxSizeUnit === "MB" ? this.maxSize * this.mb : this.maxSize * this.kb;
    return this.sizeOfAllFilesByte <= e;
  }
  dispatchChangeEvent() {
    const e = new CustomEvent("onChange", { bubbles: !0, cancelable: !1, composed: !0, detail: { value: this.allFiles } });
    this.dispatchEvent(e);
  }
  openFileUpload() {
    var t;
    const e = document.createElement("input");
    e.type = "file", e.multiple = !this.singleFileUpload, e.accept = this.fileTypes, e.hidden = !0, e.addEventListener("change", (i) => this.handleUploadedFile(i)), (t = this.shadowRoot) == null || t.appendChild(e), e.click(), this.error = !1, this.interactive = !1;
  }
  updated(e) {
    super.updated(e), e.has("errorState") && (this.error = this.errorState);
  }
  getIcon() {
    return this.icon && this.size !== "medium" ? p` <ex-icon
        id="icon"
        size="S"
        class=${g({ icon: !0, "icon-disabled": this.disabled })}
        icon="Upload"
        label=${this.iconLabel}
      ></ex-icon>` : "";
  }
  renderHelpText() {
    return this.helpText ? p`<div class="form-control__help-text">${this.helpText}</div>` : p`${m}`;
  }
  getErrorMessage() {
    return this.error ? p`<span class="error-state">
        ${this.errorMsg ? this.errorMsg : this.errorMessage.footer}
      </span>` : m;
  }
  renderFooter() {
    return this.error ? this.getErrorMessage() : (this.footerText = this.helpText || this.getMessage(this.maxSize, this.maxSizeUnit), p`<div>${this.footerText}</div>`);
  }
  removeFile(e) {
    this.allFiles = this.allFiles.filter((i, a) => a !== e), this.uploadedFileNames = this.uploadedFileNames.filter((i, a) => a !== e), this.uploadedFileTypes = this.uploadedFileTypes.filter((i, a) => a !== e), this.sizeOfAllFilesByte = this.allFiles.reduce((i, a) => i + a.size, 0);
    const t = new CustomEvent("onChange", { bubbles: !0, cancelable: !1, composed: !0, detail: { value: this.allFiles } });
    this.dispatchEvent(t);
  }
  render() {
    const e = this.uploadedFileNames.length > 0, t = { "interactive-state": this.interactive, "disable-state": this.disabled, "large-size": this.size === "large", "medium-size": this.size === "medium" };
    return p`${this.header ? p`<div
            class=${g({ header: !0, "header-disabled": this.disabled })}
          >
            ${this.header}
          </div>` : m}
      <section
        class="${g(t)}"
        @dragover="${this.handleDropZoneDragover}"
        @dragleave="${this.handleDropZoneDragleave}"
        @drop="${this.handleDropZoneDrop}"
        aria-disabled="${!this.disabled}"
      >
        ${this.getIcon()}
        <article>
          <span>${this.mainText}</span>
          <label for="fileUpload" tabindex="-1">
            <ex-button
              @click="${this.openFileUpload}"
              type="secondary"
              flavor="base"
              size="small"
              ?disabled=${this.disabled}
              aria-disabled=${this.disabled}
              data-exo-locatorId-suffix=${E(this, "file-uploader-button")}
              >${this.buttonText}</ex-button
            >
          </label>
          <input
            hidden
            multiple=${!this.singleFileUpload}
            id="fileUpload"
            type="file"
            ?disabled=${this.disabled}
            accept="${this.fileTypes}"
            @change=${(i) => this.handleUploadedFile(i)}
          />
        </article>
      </section>
      ${this.disabled ? m : p`<footer>${this.renderFooter()}</footer>`}
      ${e ? p`
            <div class="file-uploader-attachment">
              ${this.uploadedFileNames.map((i, a) => {
      const r = this.fileUploadStates[i];
      let d = "";
      r === c.IN_PROGRESS ? d = "Uploading..." : r === c.COMPLETED && (d = "Upload Complete");
      const x = [...z, ...T].includes(`${this.uploadedFileTypes[a]} file`) ? `${this.uploadedFileTypes[a]} file` : "File";
      return p`
                  <ex-loader
                    variant="progress-bar"
                    size="medium"
                    state=${r}
                    leadingicon="${x}"
                    label="${i}"
                    help-text=${d}
                    errormsg="Error. File exceeds size limit"
                    value="60"
                    showactions=""
                    @onClose="${() => this.removeFile(a)}"
                  ></ex-loader>
                `;
    })}
            </div>
          ` : m} `;
  }
}
s.styles = f`
    ${b(`:host{gap:4px;display:flex;flex-direction:column;min-width:240px;width:100%}:host .header{display:flex;height:16px;padding:0 var(--exo-spacing-4x-small);align-items:center;gap:var(--exo-spacing-2x-small);color:var(--exo-color-font);font:var(--exo-text-caption-ui)}:host .header.header-disabled{color:var(--exo-color-font-secondary)}:host section{display:flex;justify-content:center;align-items:center;flex-direction:column;font:var(--exo-text-caption-ui);color:var(--exo-color-background-deselected);background-color:var(--exo-color-background);padding:var(--exo-spacing-small) var(--exo-spacing-standard);flex:1 0 0;border-radius:var(--exo-spacing-2x-small);border:var(--exo-spacing-4x-small) dashed var(--exo-color-border-secondary);user-select:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;box-sizing:border-box;position:relative;transition:background-color .3s ease,border-color .3s ease}:host section:hover:not(.disable-state){border-color:var(--exo-color-background-selected);background:var(--exo-color-background-action-secondary-hover)}:host section:focus-visible:not(.disable-state){border:var(--exo-spacing-4x-small) dashed var(--exo-color-background-selected)}:host section.medium-size{padding:var(--exo-spacing-x-small) var(--exo-spacing-small)}:host section.medium-size article{display:flex;justify-content:center;align-items:baseline;flex-direction:row;margin-top:var(--exo-spacing-2x-small)}:host section.medium-size article span{padding:8px 0;margin-bottom:0}:host section.disable-state{background-color:var(--exo-color-background);color:var(--exo-color-background-disabled)}:host section.interactive-state:not(.disable-state){border-color:var(--exo-color-background-selected);background:var(--exo-color-background-action-secondary-hover)}:host section span{margin-bottom:var(--exo-spacing-x-small);display:flex;justify-content:center;text-align:center}:host article span{font:var(--exo-text-caption-ui);margin-bottom:var(--exo-spacing-small)}:host article label{display:flex;justify-content:center}:host article label:not(:host section.medium-size :host article label){margin-left:var(--exo-spacing-x-small)}:host footer{font:var(--exo-text-caption-ui);color:var(--exo-color-background-info-strong)}:host footer .error-state{color:var(--exo-color-font-danger);display:block}:host .file-uploader-attachment{display:flex;padding:var(--exo-spacing-x-small);flex-direction:column;align-items:flex-start;gap:var(--exo-spacing-x-small);border-radius:var(--exo-spacing-x-small);background:var(--exo-color-background-secondary);margin-top:var(--exo-spacing-x-small)}:host .icon{display:flex;justify-content:center;align-items:center;margin-bottom:var(--exo-spacing-2x-small);color:var(--exo-color-icon-secondary)}:host .icon.icon-disabled{color:var(--exo-color-background-disabled)}
`)}
  `, o([n()], s.prototype, "errorMessage", 2), o([h()], s.prototype, "sizeOfAllFilesByte", 2), o([h()], s.prototype, "error", 2), o([h()], s.prototype, "mb", 2), o([h()], s.prototype, "kb", 2), o([h()], s.prototype, "mainText", 2), o([h()], s.prototype, "buttonText", 2), o([n({ type: Boolean, reflect: !0 })], s.prototype, "icon", 2), o([n({ type: Boolean, reflect: !0 })], s.prototype, "interactive", 2), o([n({ type: Boolean, reflect: !0 })], s.prototype, "errorState", 2), o([n()], s.prototype, "allFiles", 2), o([n()], s.prototype, "fileTypes", 2), o([n({ type: Number })], s.prototype, "maxSize", 2), o([n({ type: String })], s.prototype, "maxSizeUnit", 2), o([n()], s.prototype, "size", 2), o([h()], s.prototype, "footerText", 2), o([n({ attribute: "help-text" })], s.prototype, "helpText", 2), o([n({ attribute: "error-msg" })], s.prototype, "errorMsg", 2), o([n({ type: Boolean, reflect: !0 })], s.prototype, "disabled", 2), o([n({ type: Boolean })], s.prototype, "singleFileUpload", 2), o([n({ type: String })], s.prototype, "iconLabel", 2), o([h()], s.prototype, "uploadedFileTypes", 2), o([h()], s.prototype, "uploadedFileNames", 2), o([n({ type: String })], s.prototype, "header", 2), o([h()], s.prototype, "fileUploadStates", 2);
const C = (l = "") => {
  y("ex-file-uploader", s, l), S(l), $(l), U(l);
}, q = F({ tagName: "ex-file-uploader", elementClass: s, react: u, events: { onChange: "onChange" }, displayName: "ExFileUploader", registerWebComponent: C });
export {
  D as ElementSize,
  q as ExFileUploader,
  M as SizeUnit,
  C as register
};
